export default __webpack_public_path__ + "static/media/2c.64a991e7.svg";